/*eslint-disable react/no-danger*/
import React, {PropTypes} from 'react';
import TextInput from '../../common/TextInput';
import Button from '../../common/Button';
import '../../../styles/profile/profileForm.css';

const ProfileUpdateForm = ({
  user,
  form,
  onChange,
  onSubmit,
  resetFields,
  onBlur,
  errors,
  submitStatus
}) => {
  const searchParams = new URLSearchParams(window.location.search);
  const updateRequired = searchParams.get('update_required');
  let questions = [];
  const ignoreFields = ["username", "emailConfirmation"];
  if (form.formQuestions) {
    form
      .formQuestions
      .forEach(question => {
        let questionParts = [];
        question
          .questionParts
          .map(questionPart => {
            let isFieldReadOnly = false;
            if (questionPart.questionPartName == "email") {
              isFieldReadOnly = true;
            }
            if (ignoreFields.indexOf(questionPart.questionPartName) == -1) {
              let defaultValue = (questionPart.questionPartName == "phoneNumber")
                ? defaultValue = user['phoneNumber']
                : defaultValue = user[questionPart.questionPartName];
              questionParts.push(
                <span className="question-part" key={questionPart.questionPartName}>
                  <TextInput
                    type="text"
                    onChange={onChange}
                    placeHolder={questionPart.questionPartLabel}
                    label={questionPart.questionPartLabel}
                    name={questionPart.questionPartName}
                    readOnly={isFieldReadOnly}
                    className="userCreation-text-input"
                    fieldClass={questionPart.questionPartName}
                    defaultValue={defaultValue}
                    error={errors[questionPart.questionPartName]}
                    tooltip={questionPart.questionPartTooltipHelp}
                    contextHelp={questionPart.questionPartContextHelp}
                    required={questionPart.questionPartRequired == "1"}
                    onBlur={onBlur}/>
                </span>
              );
            }
          });
        questions.push(
          <span className="question" key={question.questionID || question.questionName}>
            {question.questionGroupHelpText && <div
              dangerouslySetInnerHTML={{
              __html: question.questionGroupHelpText
            }}/>}
            {questionParts}
          </span>
        );
      });
  }

  return (
    <div className="col-xs-12 col-sm-9" id="profile-update-panel">
      <div className="border-container col-xs-12">
        <div className="basic-info-header">
          <h2>
            Profile
          </h2>
          {updateRequired ? <p>Profile update is required</p> : ''}
        </div>
        <div className="basic-info-body">
          <div className="required-info">
            <span className="required-asterisk">*</span>
            <strong>
              Required Fields</strong>
          </div>
          <form>
            {questions}
            <div className="profile-btns">
              <div id="submit-profile" className="pull-right">
                <Button
                  className="submit-profile"
                  value="Save Updates"
                  onClick={onSubmit}
                  disabled={!submitStatus}/>
              </div>
              <div id="cancel-profile-changes" className="pull-right btn btn-cancel">
                <a href='#' onClick={resetFields}>Cancel</a>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

ProfileUpdateForm.propTypes = {
  user: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  submitStatus: PropTypes.bool.isRequired,
  errors: PropTypes.object
};

export default ProfileUpdateForm;



/** WEBPACK FOOTER **
 ** ./src/components/account/manageAccount/ProfileUpdateForm.js
 **/